"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _emotion = require("emotion");
var _reactFeather = require("react-feather");
var _propTypes = require("prop-types");
var _Timeline = _interopRequireDefault(require("../Timeline"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var container = function container(primaryColor, theme, font) {
  return /*#__PURE__*/(
    (0, _emotion.css)("display:grid;grid-template-columns:1fr 0.8fr;grid-gap:10px;padding:20px 0;font-family:", font ? font : "'Inter', sans-serif", ";.visible-small{display:none;}@media (max-width:1024px){grid-template-columns:1fr 1fr;}@media (max-width:768px){grid-template-columns:auto;.visible-large{display:none;}.visible-small{display:block;}}@keyframes show{from{opacity:0;}to{opacity:1;}}.topic{display:grid;grid-template-columns:0fr 1fr;align-items:start;grid-gap:20px;margin-bottom:50px;cursor:pointer;@media (max-width:768px){margin:30px 0 0;}.icon{background:rgba(0,0,0,0.02);padding:10px;border-radius:50%;}&:hover{color:", primaryColor, ";}.content{h2{margin:0;line-height:0.9;font-weight:400;color:", theme === 'dark' ? '#efefef' : '#262626', ";}p{margin:10px 0;}.description{color:", theme === 'dark' ? '#dfdfdf' : '#8c8c8c', ";margin-top:12px;}.subtitle{margin-top:20px;color:", theme === 'dark' ? '#dfdfdf' : '#595959', ";opacity:0;}}}.topic.active{.subtitle{animation:show 0.5s ease forwards;}svg{color:", primaryColor, ";}}")
  );
};
var getStringTime = function getStringTime(time) {
  var hour = parseInt(time / 60, 10);
  var minutes = time % 60;
  if (hour && minutes) {
    return hour + " hr " + minutes + " min";
  }
  if (hour) {
    return hour + " hr";
  }
  return minutes + " mins";
};
var TimelineOption = /*#__PURE__*/
function (_React$Component) {
  function TimelineOption(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelectedItem", function (item) {
      _this.setState({
        selectedItem: item
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTotaltime", function (chapters) {
      var timeTaken = chapters.reduce(function (total, item) {
        return total + item.duration;
      }, 0);
      return getStringTime(timeTaken);
    });
    var items = props.items;
    var initialItem = Object.keys(items)[0];
    _this.state = {
      selectedItem: initialItem
    };
    return _this;
  }
  var _proto = TimelineOption.prototype;
  _proto.render = function render() {
    var _this2 = this;

    // eslint-disable-next-line
    var _this$props = this.props,
      items = _this$props.items,
      primaryColor = _this$props.primaryColor,
      itemsToShow = _this$props.itemsToShow,
      onClick = _this$props.onClick,
      theme = _this$props.theme,
      font = _this$props.font;
    var selectedItem = this.state.selectedItem;
    return _react.default.createElement("div", {
      className: container(primaryColor, theme, font)
    }, _react.default.createElement("div", {
      className: "topics"
    }, Object.keys(items).map(function (item) {
      return _react.default.createElement(_react.default.Fragment, {
        key: item
      }, _react.default.createElement("div", {
        className: "topic " + (selectedItem === item ? 'active' : ''),
        key: items[item].title,
        onClick: function onClick() {
          return _this2.handleSelectedItem(item);
        }
      }, items[item].icon || _react.default.createElement(_reactFeather.Book, null), _react.default.createElement("div", {
        className: "content"
      }, _react.default.createElement("h2", null, items[item].title), _react.default.createElement("p", {
        className: "description"
      }, items[item].chapters.length + " topics \xB7 " + _this2.getTotaltime(items[item].chapters)), _react.default.createElement("p", {
        className: "subtitle"
      }, items[item].subtitle))), _react.default.createElement("div", {
        className: "visible-small"
      }, selectedItem === item && _react.default.createElement(_Timeline.default, {
        onClick: onClick,
        itemsToShow: itemsToShow,
        primaryColor: primaryColor,
        items: items[selectedItem].chapters,
        theme: theme
      })));
    })), _react.default.createElement("div", {
      className: "visible-large"
    }, _react.default.createElement(_Timeline.default, {
      onClick: onClick,
      itemsToShow: itemsToShow,
      primaryColor: primaryColor,
      items: items[selectedItem].chapters,
      theme: theme
    })));
  };
  _inheritsLoose(TimelineOption, _React$Component);
  return TimelineOption;
}(_react.default.Component);
TimelineOption.defaultProps = {
  itemsToShow: 3,
  primaryColor: '#7136d5',
  theme: 'light',
  font: ''
};
TimelineOption.propTypes = {
  itemsToShow: _propTypes.number,
  primaryColor: _propTypes.string,
  items: _propTypes.object,
  onClick: _propTypes.func,
  theme: _propTypes.string,
  font: _propTypes.string
};
var _default = TimelineOption;
exports.default = _default;